import Image from "next/image";

import { useState } from "react";

import { Entity } from "models/entity";

import { faCube } from "@fortawesome/free-solid-svg-icons/faCube";

import FontAwesomeIcon from "components/FontAwesomeIcon";
import { sectors } from "consts/sectors";

const EntityLogo = ({
  entity,
  size = 33,
  withAltText = true,
  showIconOnError,
}: {
  entity: Entity;
  size?: number;
  withAltText?: boolean;
  showIconOnError?: boolean;
}) => {
  const [hasError, setHasError] = useState(false);
  const { logoUrl, prettyName, sector } = entity;
  const logo = size > 50 ? logoUrl?.large : logoUrl?.small;

  if (logo && !(hasError && showIconOnError)) {
    return (
      <Image
        src={logo}
        alt={withAltText ? prettyName : ""}
        width={size}
        height={size}
        style={{
          width: size,
          height: size,
        }}
        onError={() => {
          setHasError(true);
        }}
      />
    );
  }

  const icon = sectors.find((s) => s.name === sector)?.icon || faCube;
  return (
    <div
      style={{ minWidth: size, minHeight: size }}
      className="flex items-center justify-center"
    >
      <FontAwesomeIcon
        icon={icon}
        style={{ width: (size * 2) / 3, height: (size * 2) / 3 }}
      />
    </div>
  );
};

export default EntityLogo;
